import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { createReport } from '../lib/api';
import { Button } from './ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Textarea } from './ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { toast } from 'sonner';
import { Flag } from 'lucide-react';

export default function ReportButton({ targetType, targetId, size }) {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState('');
  const [category, setCategory] = useState('other');
  const [submitting, setSubmitting] = useState(false);

  const handleReport = async () => {
    if (!reason.trim()) {
      toast.error('Veuillez indiquer une raison');
      return;
    }
    setSubmitting(true);
    try {
      await createReport({
        target_type: targetType,
        target_id: targetId,
        reason: reason.trim(),
        category: category
      });
      toast.success('Signalement envoye. Merci !');
      setOpen(false);
      setReason('');
      setCategory('other');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Erreur');
    } finally {
      setSubmitting(false);
    }
  };

  if (!user) return null;

  return (
    <React.Fragment>
      <Button
        variant="ghost"
        size={size || 'sm'}
        onClick={() => setOpen(true)}
        className="text-xs text-muted-foreground gap-1"
        data-testid="report-button"
      >
        <Flag className="w-3 h-3" />
        Signaler
      </Button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle className="font-heading">Signaler ce contenu</DialogTitle>
            <DialogDescription>
              Aidez-nous a maintenir la qualite des discussions.
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-4">
            <div>
              <label className="text-sm font-medium mb-1 block">Categorie</label>
              <Select value={category} onValueChange={setCategory}>
                <SelectTrigger>
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="spam">Spam</SelectItem>
                  <SelectItem value="harassment">Harcelement</SelectItem>
                  <SelectItem value="misinformation">Desinformation</SelectItem>
                  <SelectItem value="personal_advice">Conseil medical personnalise</SelectItem>
                  <SelectItem value="other">Autre</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div>
              <label className="text-sm font-medium mb-1 block">Raison</label>
              <Textarea
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                placeholder="Decrivez le probleme..."
                className="min-h-[100px]"
                data-testid="report-reason-textarea"
              />
            </div>
            <Button
              onClick={handleReport}
              disabled={submitting || !reason.trim()}
              className="w-full"
              data-testid="submit-report-button"
            >
              {submitting ? 'Envoi...' : 'Envoyer le signalement'}
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}
